import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, AppBar, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";

// Components
import TabImages from "./TabImages";
import TabReviews from "./TabReviews";

const useStyles = makeStyles((theme) => ({
  content: {
    margin: "0.5rem auto",
  },
  appbar: {
    zIndex: "auto",
  },
  tabPanel: {
    padding: "0.3rem 0.1rem 0.1rem 0.2rem",
    width: "100%",
    height: 400,
    border: "1px solid lightgrey",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
  root: {
    width: "100%",
    height: "100%",
    paddingTop: theme.spacing(0.5),
  },
}));

const TabForm = ({ current_tab, changeTab }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} container className={classes.content}>
      <TabContext value={current_tab}>
        <AppBar
          position="static"
          color="transparent"
          className={classes.appbar}
        >
          <TabList
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
            onChange={changeTab}
          >
            <Tab label="Images" value="Images" className={classes.button} />
            <Tab label="Reviews" value="Reviews" className={classes.button} />
          </TabList>
        </AppBar>
        <TabPanel value={current_tab} className={classes.tabPanel}>
          <Grid container className={classes.root}>
            {current_tab === "Images" && <TabImages />}
            {current_tab === "Reviews" && <TabReviews />}
          </Grid>
        </TabPanel>
      </TabContext>
    </Grid>
  );
};

export default TabForm;
